var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionFlatline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "production-flatline",
    imageName: "Production",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_149_production_flatline",
    "data-name": "#149_production_flatline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.29,
    y: 116.25,
    width: 27.77,
    height: 24.31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,141.06H141.29a.5.5,0,0,1-.5-.5V116.25a.5.5,0,0,1,.5-.5h27.77a.5.5,0,0,1,.5.5v24.31A.5.5,0,0,1,169.06,141.06Zm-27.27-1h26.77V116.75H141.79Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.06,
    y: 116.25,
    width: 9.31,
    height: 24.31,
    transform: "translate(347.44 256.8) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,141.06h-9.32a.51.51,0,0,1-.5-.5V116.25a.5.5,0,0,1,.5-.5h9.32a.5.5,0,0,1,.5.5v24.31A.51.51,0,0,1,178.38,141.06Zm-8.82-1h8.32V116.75h-8.32Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.36,
    y: 116.25,
    width: 3.64,
    height: 6.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,123.3h-3.63a.5.5,0,0,1-.5-.5v-6.55a.5.5,0,0,1,.5-.5H157a.5.5,0,0,1,.5.5v6.55A.5.5,0,0,1,157,123.3Zm-3.13-1h2.63v-5.55h-2.63Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.34,135.17h-4.22a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h4.22a.51.51,0,0,1,.5.5A.5.5,0,0,1,148.34,135.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.29,124a1,1,0,0,1-.89-.53l-3.25-6.06a1,1,0,0,1,.31-1.3l19-13.41a1,1,0,0,1,1.4.25,1,1,0,0,1-.24,1.39l-18.32,12.9,2.84,5.28a1,1,0,0,1-.88,1.48Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.73,124a1,1,0,0,1-.48-.12,1,1,0,0,1-.4-1.36l2.83-5.28-18.31-12.9a1,1,0,0,1,1.15-1.64l19,13.41a1,1,0,0,1,.31,1.3l-3.25,6.06A1,1,0,0,1,173.73,124Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,103.54a1,1,0,0,1-1-1V82.14a1,1,0,1,1,2,0v20.4A1,1,0,0,1,157,103.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.3,
    y: 79.85,
    width: 9.41,
    height: 9.41,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71,89.76H152.3a.5.5,0,0,1-.5-.5V79.85a.51.51,0,0,1,.5-.5h9.41a.5.5,0,0,1,.5.5v9.41A.5.5,0,0,1,161.71,89.76Zm-8.91-1h8.41V80.35H152.8Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.82,
    y: 73.19,
    width: 50.18,
    height: 11.36,
    rx: 5.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.32,85.06H122.51a6.19,6.19,0,0,1,0-12.37h38.81a6.19,6.19,0,1,1,0,12.37ZM122.51,73.69a5.19,5.19,0,0,0,0,10.37h38.81a5.19,5.19,0,1,0,0-10.37Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.41,
    y: 65.46,
    width: 20.1,
    height: 71.49,
    rx: 10.05,
    transform: "matrix(0.86, 0.51, -0.51, 0.86, 66.6, -41.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.36,133.88A10.55,10.55,0,0,1,86.3,118l26.15-44.24a10.55,10.55,0,1,1,18.17,10.74L104.46,128.7A10.51,10.51,0,0,1,98,133.55,10.93,10.93,0,0,1,95.36,133.88Zm26.19-64.35a9.28,9.28,0,0,0-2.39.31,9.47,9.47,0,0,0-5.85,4.39L87.16,118.47a9.55,9.55,0,1,0,16.44,9.72L129.76,84a9.56,9.56,0,0,0-3.36-13.08A9.46,9.46,0,0,0,121.55,69.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.6,
    cy: 77.29,
    r: 3.02,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,80.81a3.53,3.53,0,1,1,3.52-3.52A3.53,3.53,0,0,1,122.6,80.81Zm0-6a2.53,2.53,0,1,0,2.52,2.53A2.52,2.52,0,0,0,122.6,74.76Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.44,119h0a17.37,17.37,0,0,1,17.37,17.37v86.12a0,0,0,0,1,0,0H76.07a0,0,0,0,1,0,0V136.4A17.37,17.37,0,0,1,93.44,119Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,223H76.07a.5.5,0,0,1-.5-.5V136.4a17.88,17.88,0,1,1,35.75,0v86.12A.51.51,0,0,1,110.82,223Zm-34.25-1h33.75V136.4a16.88,16.88,0,1,0-33.75,0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.44,
    cy: 133.38,
    r: 8.06,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.44,141.94a8.56,8.56,0,1,1,8.57-8.56A8.57,8.57,0,0,1,93.44,141.94Zm0-16.12a7.56,7.56,0,1,0,7.57,7.56A7.57,7.57,0,0,0,93.44,125.82Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.63 228.52 57.52 228.52 57.52 173.79 283.03 173.79 341.63 228.52",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.87,
    y: 130.59,
    width: 27.77,
    height: 24.31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.64,155.4H191.87a.5.5,0,0,1-.5-.5V130.59a.5.5,0,0,1,.5-.5h27.77a.5.5,0,0,1,.5.5V154.9A.5.5,0,0,1,219.64,155.4Zm-27.27-1h26.77V131.09H192.37Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.64,
    y: 130.59,
    width: 9.31,
    height: 24.31,
    transform: "translate(448.6 285.49) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,155.4h-9.32a.5.5,0,0,1-.5-.5V130.59a.5.5,0,0,1,.5-.5H229a.5.5,0,0,1,.5.5V154.9A.5.5,0,0,1,229,155.4Zm-8.82-1h8.32V131.09h-8.32Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.94,
    y: 130.59,
    width: 3.64,
    height: 6.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.57,137.65h-3.63a.5.5,0,0,1-.5-.5v-6.56a.5.5,0,0,1,.5-.5h3.63a.5.5,0,0,1,.5.5v6.56A.5.5,0,0,1,207.57,137.65Zm-3.13-1h2.63v-5.56h-2.63Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.92,149.52h-4.21a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.21a.5.5,0,0,1,.5.5A.51.51,0,0,1,198.92,149.52Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.27,
    y: 130.59,
    width: 27.77,
    height: 24.31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.05,155.4H246.27a.5.5,0,0,1-.5-.5V130.59a.5.5,0,0,1,.5-.5h27.78a.5.5,0,0,1,.5.5V154.9A.5.5,0,0,1,274.05,155.4Zm-27.28-1h26.78V131.09H246.77Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.05,
    y: 130.59,
    width: 9.31,
    height: 24.31,
    transform: "translate(557.41 285.49) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,155.4h-9.31a.5.5,0,0,1-.5-.5V130.59a.5.5,0,0,1,.5-.5h9.31a.5.5,0,0,1,.5.5V154.9A.5.5,0,0,1,283.36,155.4Zm-8.81-1h8.31V131.09h-8.31Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.34,
    y: 130.59,
    width: 3.64,
    height: 6.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,137.65h-3.64a.5.5,0,0,1-.5-.5v-6.56a.5.5,0,0,1,.5-.5H262a.5.5,0,0,1,.5.5v6.56A.51.51,0,0,1,262,137.65Zm-3.14-1h2.64v-5.56h-2.64Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.32,149.52h-4.21a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.21a.5.5,0,0,1,.5.5A.5.5,0,0,1,253.32,149.52Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.77,
    y: 162.6,
    width: 27.77,
    height: 24.31,
    transform: "translate(234.82 -183.49) rotate(47.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,193.7a.49.49,0,0,1-.37-.16l-18.75-20.49a.53.53,0,0,1-.13-.36.54.54,0,0,1,.16-.35l17.94-16.41a.5.5,0,0,1,.71,0l18.75,20.5a.53.53,0,0,1,.13.36.57.57,0,0,1-.16.35l-17.94,16.4A.5.5,0,0,1,326.06,193.7Zm-18-21,18.07,19.76,17.2-15.74L325.22,157Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.51,
    y: 176.28,
    width: 9.31,
    height: 24.31,
    transform: "translate(427.36 565.15) rotate(-132.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.34,200.58h0a.53.53,0,0,1-.35-.17l-6.28-6.87a.5.5,0,0,1,0-.71l17.94-16.4a.49.49,0,0,1,.36-.13.48.48,0,0,1,.35.16l6.28,6.87a.5.5,0,0,1,0,.71l-17.94,16.41A.51.51,0,0,1,332.34,200.58Zm-5.58-7.34,5.62,6.13,17.2-15.73L344,177.5Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.39,
    y: 165.48,
    width: 3.64,
    height: 6.56,
    transform: "translate(232.52 -190.27) rotate(47.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,172.82h0a.48.48,0,0,1-.35-.16L328.19,170a.5.5,0,0,1,0-.71l4.84-4.42a.44.44,0,0,1,.36-.13.48.48,0,0,1,.35.16l2.45,2.68a.5.5,0,0,1,0,.71l-4.84,4.42A.48.48,0,0,1,331,172.82Zm-1.74-3.16,1.77,2,4.11-3.75-1.78-2Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.41,174.44a.54.54,0,0,1-.37-.16l-2.84-3.11a.5.5,0,0,1,.74-.68l2.84,3.11a.5.5,0,0,1-.37.84Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,231a9.77,9.77,0,0,1-7.24-3.21l-51.8-57.18a9.76,9.76,0,0,1,14.47-13.11l51.8,57.18A9.77,9.77,0,0,1,338.11,231Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,231.46a10.25,10.25,0,0,1-7.61-3.37l-51.8-57.17a10.26,10.26,0,1,1,15.21-13.78l51.8,57.17a10.25,10.25,0,0,1-7.6,17.15ZM286.3,154.77a9.26,9.26,0,0,0-6.86,15.48l51.8,57.17A9.26,9.26,0,1,0,345,215l-51.8-57.17A9.21,9.21,0,0,0,286.3,154.77Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.92,173.79H59.48a9.77,9.77,0,0,1,0-19.53H285.92a9.77,9.77,0,0,1,0,19.53Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.92,174.29H59.48a10.27,10.27,0,0,1,0-20.53H285.92a10.27,10.27,0,0,1,0,20.53ZM59.48,154.76a9.27,9.27,0,0,0,0,18.53H285.92a9.27,9.27,0,0,0,0-18.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 163.32,
    r: 3.84,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,167.65a4.34,4.34,0,1,1,4.34-4.33A4.33,4.33,0,0,1,283,167.65Zm0-7.67a3.34,3.34,0,1,0,3.34,3.34A3.34,3.34,0,0,0,283,160Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.47,
    cy: 163.32,
    r: 3.84,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.47,167.65a4.34,4.34,0,1,1,4.34-4.33A4.33,4.33,0,0,1,66.47,167.65Zm0-7.67a3.34,3.34,0,1,0,3.34,3.34A3.34,3.34,0,0,0,66.47,160Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.47,
    y: 204.45,
    width: 6.19,
    height: 10.88,
    rx: 1.24,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 204.45,
    width: 6.19,
    height: 10.88,
    rx: 1.24,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.63,
    y: 76.79,
    width: 130.83,
    height: 31.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.46,108.38H208.63a.5.5,0,0,1-.5-.5V76.79a.51.51,0,0,1,.5-.5H339.46a.5.5,0,0,1,.5.5v31.09A.5.5,0,0,1,339.46,108.38Zm-130.33-1H339V77.29H209.13Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,108.38a.5.5,0,0,1-.5-.5V76.79a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v31.09A.5.5,0,0,1,241.82,108.38Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.05,108.38a.5.5,0,0,1-.5-.5V76.79a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v31.09A.5.5,0,0,1,274.05,108.38Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,108.38a.5.5,0,0,1-.5-.5V76.79a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v31.09A.5.5,0,0,1,306.27,108.38Z",
    fill: "#d1d3d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionFlatline);
export default __webpack_public_path__ + "static/media/production-flatline.1b0609ccf49f5ac890eabd1738479f3a.svg";
export { ForwardRef as ReactComponent };